(function() {

    var sectionEl = document.querySelector('.rvp-section');

    function showSection(){ sectionEl && sectionEl.classList.remove('is-hidden'); }
    function hideSection(){ sectionEl && sectionEl.classList.add('is-hidden'); }  

    var KEY = 'rv_handles';
    var grid = document.querySelector('.rvp-grid[data-section-id]');
    if (!grid) return;

    var limit = parseInt(grid.getAttribute('data-limit') || '6', 10);
    var currentHandle = grid.getAttribute('data-current-handle') || '';

    // Attach once (outside render), delegated to labels we generate
    grid.addEventListener('click', function (e) {
        var label = e.target.closest('.swatch-label');
        if (!label || !grid.contains(label)) return;

        var image = label.getAttribute('data-img');
        var price = label.getAttribute('data-price');
        var productId = label.getAttribute('data-product-id');

        // 1) Update inside the same card (correct scope)
        var card = label.closest('.product');
        if (card) {
            var imgInCard = card.querySelector(`.wishlist-img-${productId}`);
            if (imgInCard && image) imgInCard.src = image;

            card.querySelectorAll(`.price-wishlist-p-${productId}`).forEach(function(node){
            node.textContent = price;
            });
        }

        // 2) Also update all Slick clones so the UI stays consistent when sliding
        document.querySelectorAll(`.wishlist-img-${productId}`).forEach(function(img){
            if (image) img.src = image;
        });
        document.querySelectorAll(`.price-wishlist-p-${productId}`).forEach(function(node){
            node.textContent = price;
        });

        // 3) Toggle active state
        var list = label.closest('.swatch');
        if (list) {
            list.querySelectorAll('.swatch-label.is-active').forEach(function(el){ el.classList.remove('is-active'); });
        }
        label.classList.add('is-active');
    });

    const translatedColorCodes = {
        "جرافييت": { color_hex: "#787571", translated_color_name: "جرافييت", attribute_name: "Graphite" },
        "رصاصي": { color_hex: "#c0c0c0", translated_color_name: "رصاصي", attribute_name: "Silver" },
        "أزرق_محيطي": { color_hex: "#2d4854", translated_color_name: "أزرق محيطي", attribute_name: "Pacific Blue" },
        "ذهبي": { color_hex: "#f0dec6", translated_color_name: "ذهبي", attribute_name: "Gold" },
        "أخضر_صنوبري": { color_hex: "#5B6C5A", translated_color_name: "أخضر صنوبري", attribute_name: "Alpine Green" },
        "أبيض": { color_hex: "#ffffff", translated_color_name: "أبيض", attribute_name: "White" },
        "أسود": { color_hex: "#000000", translated_color_name: "أسود", attribute_name: "Black" },
        "التيتانيوم_الأسود": { color_hex: "#464443", translated_color_name: "التيتانيوم الأسود", attribute_name: "Black Titanium" },
        "أزرق": { color_hex: "#D2D8EB", translated_color_name: "أزرق", attribute_name: "Blue" },
        "التيتانيوم_الأزرق": { color_hex: "#5F778A", translated_color_name: "التيتانيوم الأزرق", attribute_name: "Blue Titanium" },
        "تيتانيوم_طبيعي": { color_hex: "#797982", translated_color_name: "تيتانيوم طبيعي", attribute_name: "Natural Titanium" },
        "مرجاني": { color_hex: "#FF7F50", translated_color_name: "مرجاني", attribute_name: "Coral" },
        "ليلكي_عميق": { color_hex: "#800080", translated_color_name: "ليلكي عميق", attribute_name: "Deep Purple" },
        "أخضر": { color_hex: "#8EAB94", translated_color_name: "أخضر", attribute_name: "Green" },
        "أسود_لامع": { color_hex: "#000000", translated_color_name: "أسود لامع", attribute_name: "Jet Black" },
        "أخضر_الليل": { color_hex: "#406A57", translated_color_name: "أخضر الليل", attribute_name: "Midnight Green" },
        "وردي": { color_hex: "#FFC0CB", translated_color_name: "وردي", attribute_name: "Pink" },
        "بنفسجي_فاتح": { color_hex: "#B8AFE6", translated_color_name: "بنفسجي فاتح", attribute_name: "Purple" },
        "أحمر": { color_hex: "#B50D1E", translated_color_name: "أحمر", attribute_name: "Red" },
        "ذهبي_وردي": { color_hex: "#EFCCC8", translated_color_name: "ذهبي وردي", attribute_name: "Rose Gold" },
        "أزرق_سييرا": { color_hex: "#95ACC4", translated_color_name: "أزرق سييرا", attribute_name: "Sierra Blue" },
        "الأسود_الفلكي": { color_hex: "#000000", translated_color_name: "الأسود الفلكي", attribute_name: "Space Black" },
        "رمادي_فلكي": { color_hex: "#5F5D5C", translated_color_name: "رمادي فلكي", attribute_name: "Space Grey" },
        "ضوء_النجوم": { color_hex: "#FCF9F6", translated_color_name: "ضوء النجوم", attribute_name: "Starlight" },
        "الأصفر": { color_hex: "#FEE681", translated_color_name: "الأصفر", attribute_name: "Yellow" },
        "الجير_الأخضر": { color_hex: "#DDF4DA", translated_color_name: "الجير الأخضر", attribute_name: "Lime Green" },
        "فضي_ثلجي": { color_hex: "#C0C0C0", translated_color_name: "فضي ثلجي", attribute_name: "Arctic Silver" },
        "أزرق_مرجاني": { color_hex: "#0000FF", translated_color_name: "أزرق مرجاني", attribute_name: "Coral Blue" },
        "أسود_كوزميك": { color_hex: "#000000", translated_color_name: "أسود كوزميك", attribute_name: "Cosmic Black" },
        "رمادي": { color_hex: "#808080", translated_color_name: "رمادي", attribute_name: "Grey" },
        "لافندر": { color_hex: "#E6E6FA", translated_color_name: "لافندر", attribute_name: "Lavender" },
        "أسود_منتصف_الليل": { color_hex: "#000000", translated_color_name: "أسود منتصف الليل", attribute_name: "Midnight Black" },
        "أسود_مستيك": { color_hex: "#000000", translated_color_name: "أسود مستيك", attribute_name: "Mystic Black" },
        "برونزي_مستيك": { color_hex: "#D7AC94", translated_color_name: "برونزي مستيك", attribute_name: "Mystic Bronze" },
        "رمادي_أوركيد": { color_hex: "#808080", translated_color_name: "رمادي أوركيد", attribute_name: "Orchid Gray" },
        "أسود_فانتوم": { color_hex: "#000000", translated_color_name: "أسود فانتوم", attribute_name: "Phantom Black" },
        "رمادي_فانتوم": { color_hex: "#808080", translated_color_name: "رمادي فانتوم", attribute_name: "Phantom Gray" },
        "أخضر_فانتوم": { color_hex: "#414B45", translated_color_name: "أخضر فانتوم", attribute_name: "Phantom Green" },
        "وردي_فانتوم": { color_hex: "#FFC0CB", translated_color_name: "وردي فانتوم", attribute_name: "Phantom Pink" },
        "فضي_فانتوم": { color_hex: "#DEDEEC", translated_color_name: "فضي فانتوم", attribute_name: "Phantom Silver" },
        "أبيض_فانتوم": { color_hex: "#ffffff", translated_color_name: "أبيض فانتوم", attribute_name: "Phantom White" },
        "أزرق_بولاريس": { color_hex: "#0000FF", translated_color_name: "أزرق بولاريس", attribute_name: "Polaris Blue" },
        "أسود_بريزم": { color_hex: "#000000", translated_color_name: "أسود بريزم", attribute_name: "Prism Black" },
        "أزرق_بريزم": { color_hex: "#0000FF", translated_color_name: "أزرق بريزم", attribute_name: "Prism blue" },
        "بريزم_كراش_أسود": { color_hex: "#000000", translated_color_name: "بريزم كراش أسود", attribute_name: "Prism Crush Black" },
        "بريزم_كراش_أزرق": { color_hex: "#0000FF", translated_color_name: "بريزم كراش أزرق", attribute_name: "Prism Crush Blue" },
        "بريزم_كراش_وردي": { color_hex: "#FFC0CB", translated_color_name: "بريزم كراش وردي", attribute_name: "Prism Crush Pink" },
        "بريزم_كراش_فضي": { color_hex: "#B38879", translated_color_name: "بريزم كراش فضي", attribute_name: "Prism Crush Silver" },
        "أخضر_بريزم": { color_hex: "#008000", translated_color_name: "أخضر بريزم", attribute_name: "Prism Green" },
        "فضي_بريزم": { color_hex: "#C0C0C0", translated_color_name: "فضي بريزم", attribute_name: "Prism Silver" },
        "أبيض_بريزم": { color_hex: "#ffffff", translated_color_name: "أبيض بريزم", attribute_name: "Prism White" },
        "ذهبي_زهري": { color_hex: "#FFC0CB", translated_color_name: "ذهبي زهري", attribute_name: "Rose Pink" },
        "ذهبي_ملكي": { color_hex: "#FFD700", translated_color_name: "ذهبي ملكي", attribute_name: "Royal Gold" },
        "أزرق_سماوي": { color_hex: "#0000FF", translated_color_name: "أزرق سماوي", attribute_name: "Sky Blue" },
        "شروق_الشمس": { color_hex: "#FFD700", translated_color_name: "شروق الشمس", attribute_name: "Sunrise Gold" },
        "رمادي_تيتانيوم": { color_hex: "#808080", translated_color_name: "رمادي تيتانيوم", attribute_name: "Titanium Gray" },
        "أبيض_لؤلؤي": { color_hex: "#ffffff", translated_color_name: "أبيض لؤلؤي", attribute_name: "White Pearl" },
        "بيج": { color_hex: "#f5f5dc", translated_color_name: "بيج", attribute_name: "Beige" },
        "نعناعي": { color_hex: "#a5d1bb", translated_color_name: "نعناعي", attribute_name: "Mint" },
        "مشمشي": { color_hex: "#ffdab9", translated_color_name: "مشمشي", attribute_name: "Peach" },
        "بنفسجي_فانتوم": { color_hex: "#9A99B9", translated_color_name: "بنفسجي فانتوم", attribute_name: "Phantom Violet" },
        "بنفسجي": { color_hex: "#ee82ee", translated_color_name: "بنفسجي", attribute_name: "Violet" },
        "أخضر_ليموني": { color_hex: "#ddf4da", translated_color_name: "أخضر_ليموني", attribute_name: "Lime Green" },
        "أسود_فضائي": { color_hex: "#323233", translated_color_name: "أسود_فضائي", attribute_name: "Space Black" },
        "أرجواني_داكن": { color_hex: "#800080", translated_color_name: "أرجواني_داكن", attribute_name: "Deep Purple" },
        "منتصف_الليل": { color_hex: "#000000", translated_color_name: "منتصف الليل", attribute_name: "Midnight" },
        "رمادي_فضائي": { color_hex: "#62615F", translated_color_name: "رمادي_فضائي", attribute_name: "Space Grey" },
        "أخضر_منتصف_الليل": { color_hex: "#406a57", translated_color_name: "أخضر_منتصف_الليل", attribute_name: "Midnight Green" },
        "سماء_الليل": { color_hex: "#000000", translated_color_name: "سماء الليل", attribute_name: "Midnight" },
        "التيتانيوم_الأبيض": { color_hex: "#E0E0DC", translated_color_name: "التيتانيوم الأبيض", attribute_name: "White Titanium" },
        "التيتانيوم_الطبيعي": { color_hex: "#5f778a", translated_color_name: "التيتانيوم الطبيعي", attribute_name: "Natural Titanium" },
        "أسود فانتوم": { color_hex: "#000000", translated_color_name: "أسود فانتوم", attribute_name: "Phantom Black" },
        "تيتانيوم_الصحراء": { color_hex: "#594e4a", translated_color_name: "تيتانيوم الصحراء", attribute_name: "Desert Titanium" },
        "أزرق_داكن": { color_hex: "#8191cf", translated_color_name: "أزرق داكن", attribute_name: "Ultramarine" },
        "أزرق_مخضر": { color_hex: "#008080", translated_color_name: "أزرق مخضر", attribute_name: "Teal" },
        "أزرق جليدي": { color_hex: "#a6afc2", translated_color_name: "أزرق جليدي", attribute_name: "Icy Blue" },
        "الأزرق": { color_hex: "#D2D8EB", translated_color_name: "الأزرق", attribute_name: "Blue" },
        "كريمة": { color_hex: "#FFFDD0", translated_color_name: "كريمة", attribute_name: "Cream" },
        "فضي_مجري": { color_hex: "#C0C0C0", translated_color_name: "فضي مجري", attribute_name: "Galactic Silver" },
        "أزرق_المحيط": { color_hex: "#0077BE", translated_color_name: "أزرق المحيط", attribute_name: "Ocean Blue" },
        "أحمر_السديم": { color_hex: "#C0392B", translated_color_name: "أحمر السديم", attribute_name: "Nebula Red" },
        "أخضر_الموجة": { color_hex: "#2ECC71", translated_color_name: "أخضر الموجة", attribute_name: "Wave Green" },
        "رمادي_صخري": { color_hex: "#7F8C8D", translated_color_name: "رمادي صخري", attribute_name: "Rock Grey" },
        "بني_غير_لامع": { color_hex: "#a52a2a", translated_color_name: "بني غير لامع", attribute_name: "Matte Brown" },
        "وردي_الغروب": { color_hex: "#ffc0cb", translated_color_name: "وردي الغروب", attribute_name: "Sunset Pink" },
        "فضي_أسترو": { color_hex: "#c0c0c0", translated_color_name: "فضي أسترو", attribute_name: "Astro Silver" },
        "رمادي تيتانيوم": { color_hex: "#ACA49B", translated_color_name: "رمادي تيتانيوم", attribute_name: "Titanium Gray" },
        "رمادي_تيتانيوم": { color_hex: "#ACA49B", translated_color_name: "رمادي تيتانيوم", attribute_name: "Titanium Gray" },
        "بنفسجي_تيتانيوم": { color_hex: "#4D4E5F", translated_color_name: "بنفسجي تيتانيوم", attribute_name: "Titanium Violet" },
        "برتقالي_تيتانيوم": { color_hex: "#C48B6C", translated_color_name: "برتقالي تيتانيوم", attribute_name: "Titanium Orange" },
        "أصفر_تيتانيوم": { color_hex: "#F0E1B9", translated_color_name: "أصفر تيتانيوم", attribute_name: "Titanium Yellow" },
        " أصفر_تيتانيوم": { color_hex: "#F0E1B9", translated_color_name: "أصفر تيتانيوم", attribute_name: "Titanium Yellow" },
        "أسود_تيتانيوم": { color_hex: "#62605F", translated_color_name: "أسود تيتانيوم", attribute_name: "Titanium Black" },
        "أزرق_تيتانيوم": { color_hex: "#A7B5C8", translated_color_name: "أزرق تيتانيوم", attribute_name: "Titanium Blue" },
        "أخضر_تيتانيوم": { color_hex: "#C2CDBA", translated_color_name: "أخضر تيتانيوم", attribute_name: "Titanium Green" },
        "بنفسجي_كوبالت": { color_hex: "#914CA6", translated_color_name: "بنفسجي كوبالت", attribute_name: "Cobalt Violet" },
        "رمادي_ماربل": { color_hex: "#BABABA", translated_color_name: "رمادي ماربل", attribute_name: "Marble Grey" },
        "أزرق_ياقوتي": { color_hex: "#0F52BA", translated_color_name: "أزرق ياقوتي", attribute_name: "Sapphire Blue" },
        "برتقالي_رمال": { color_hex: "#BFA674", translated_color_name: "برتقالي رمال", attribute_name: "Sandstone Orange" },
        "أخضر_جاد": { color_hex: "#00A86B", translated_color_name: "أخضر جاد", attribute_name: "Jade Green" },
        "أصفر_كهرماني": { color_hex: "#FFBF00", translated_color_name: "أصفر كهرماني", attribute_name: "Amber Yellow" },
        "أسود_أونيكس": { color_hex: "#3A3A3A", translated_color_name: "أسود أونيكس", attribute_name: "Onyx Black" }
    };

    function hasSellableVariant(p) {
        if (!p || !Array.isArray(p.variants)) return false;
        return p.variants.some(function(v){
            var price = parseFloat(v && v.price);
            return v && v.available === true && Number.isFinite(price) && price > 0;
        });
    }

    function isDisplayable(p) {
        if (!p) return false;
        // Exclude by product.type
        if (p.type === 'Warranty' || p.type === 'Battery') return false;
        // Product-level availability & sellable variants
        if (p.available !== true) return false;
        if (!hasSellableVariant(p)) return false;
        return true;
    }

    function normalizeTitle(t) {
        return String(t || '')
            .toLowerCase()
            .replace(/\s+/g, ' ')
            .trim();
    }

    function uniqByHandleAndTitle(products) {
        var seenHandles = new Set();
        var seenTitles  = new Set();

        return (products || []).filter(function (p) {
            if (!p) return false;

            var h = p.handle || '';
            var t = normalizeTitle(p.title);

            // If either the handle OR the normalized title was seen, drop it
            if (h && seenHandles.has(h)) return false;
            if (t && seenTitles.has(t))  return false;

            if (h) seenHandles.add(h);
            if (t) seenTitles.add(t);
            return true;
        });
    }

    function fetchProduct(handle, forDisplayOnly) {
        let language = document.documentElement.lang === "ar" ? "/ar" : "";
        return fetch(language + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
            .then(r => { if (!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
            .then(p => {
            p.url = language + '/products/' + p.handle;
            if (forDisplayOnly && !isDisplayable(p)) return null; // early drop
            return p;
            })
            .catch(() => null);
    }

    // ---- Your card (adapted) ----
    function createProductHTML(product) {
        if (!product || !product.variants || !product.available || product.type == "Warranty" || product.type == "Battery") return '';

        // Find least-priced variant with price > 0
        var lease_price = (product.variants || []).reduce(function(least, current) {
        var currentPrice = parseFloat(current.price);
        if (!Number.isFinite(currentPrice) || currentPrice <= 0) return least;
        if (!least || currentPrice < parseFloat(least.price)) return current;
        return least;
        }, null) || (product.variants && product.variants[0]) || null;

        // Guard: if no variant, short-circuit
        if (!lease_price) return '';

        var price_min = Shopify.formatMoney(lease_price.price, window.money_format);
        var compare_at = Shopify.formatMoney(lease_price.compare_at_price, window.money_format);

        // Percent badge (vs new)
        var percentageHTML = '';
        var cp = parseFloat(lease_price.compare_at_price);
        var pr = parseFloat(lease_price.price);
        if (Number.isFinite(cp) && Number.isFinite(pr) && cp > pr && cp > 0) {
        var percentage = (pr / cp) * 100;
        var integerPercentage = Math.floor(100 - percentage); // show discount amount (e.g., 25%)
        if (document.documentElement.lang === 'ar') {
            percentageHTML =
            '<div class="card__badge bdgeProduct' + product.id + ' badge-left halo-productBadges halo-productBadges--left">' +
                '<span class="badge sale-badge" aria-hidden="true">' +
                '<span class="vs-badge">مقارنة بالجديد</span> <span class="percentagebdg">-' + integerPercentage + '%</span>' +
                '</span>' +
            '</div>';
        } else {
            percentageHTML =
            '<div class="card__badge bdgeProduct' + product.id + ' badge-left halo-productBadges halo-productBadges--left">' +
                '<span class="badge sale-badge" aria-hidden="true"> -' + integerPercentage + '% vs new </span>' +
            '</div>';
        }
        }

        // ---- Swatches (group by option1, only price>0) ----
        var maxVisibleSwatches = 4;
        var groupedVariants = (product.variants || []).reduce(function(groups, variant) {
        if (!variant || !variant.option1) return groups;
        var p = parseFloat(variant.price);
        if (!Number.isFinite(p) || p <= 0) return groups;
        (groups[variant.option1] = groups[variant.option1] || []).push(variant);
        return groups;
        }, {});

        var groupedKeys = Object.keys(groupedVariants);
        // Sort by first variant price asc
        groupedKeys.sort(function(a, b) {
        var priceA = parseFloat(groupedVariants[a][0].price);
        var priceB = parseFloat(groupedVariants[b][0].price);
        return priceA - priceB;
        });

        // Featured image: prefer cheapest group's first variant → product image fallback
        var firstVariant = groupedKeys.length ? (groupedVariants[groupedKeys[0]][0] || {}) : {};
        var variantImg = firstVariant.featured_image && (firstVariant.featured_image.src || firstVariant.featured_image);
        var productImg = (product.images && product.images[0] && product.images[0].src) || product.featured_image || '';
        var featuredImageSrc = variantImg || productImg || '';

        // Make sure we have an alt
        var featuredAlt = (product.featured_image && product.featured_image.alt) || product.title || '';

        function getColorHexCodeSafe(colorName) {
            let removeSpace = colorName.replace(/\s+/g, '_');
            const color = translatedColorCodes[removeSpace] || {};
            return color && color.color_hex ? color.color_hex : null;
        }

        var swatchesHTML = groupedKeys.slice(0, maxVisibleSwatches).map(function(groupKey, index) {
        var variant = groupedVariants[groupKey][0];
        var featuredImage = (variant.featured_image && (variant.featured_image.src || variant.featured_image)) || productImg;
        var variantPrice = Shopify.formatMoney(variant.price, window.money_format);
        var activeClass = index === 0 ? 'is-active' : '';

        var colorCode = document.documentElement.lang === 'ar' ? (getColorHexCodeSafe(groupKey) || '#ccc') : groupKey;

        return ''
            + '<li class="item">'
            + '  <div class="item-wrapper clearfix">'
            + '    <label class="swatch-label ' + activeClass + '"'
            + '      data-value="' + groupKey.toLowerCase().replace(/\s+/g, '-') + '"'
            + '      title="' + groupKey + '"'
            + '      data-img="' + featuredImage + '"'
            + '      data-price="' + variantPrice + '"'
            + '      data-product-id="' + product.id + '">'
            + '        <span class="pattern" style="background-color: ' + colorCode + ';"></span> ' + groupKey
            + '    </label>'
            + '    <span class="tooltip">' + groupKey + '</span>'
            + '  </div>'
            + '</li>';
        }).join('');

        var totalColors = 0;
        (product.options || []).forEach(function(option) {
        if (option && option.name === 'Color') totalColors = option.values.length;
        });
        var additionalSwatches = totalColors - maxVisibleSwatches;
        if (additionalSwatches > 0) {
        swatchesHTML += ''
            + '<li class="item more-swatches">'
            + '  <span class="more-count">+' + additionalSwatches + '</span>'
            + '</li>';
        }

        var hasColorOption = (product.options || []).some(function(option){ return option && option.name === 'Color'; });
        var productMeta = hasColorOption
        ? '<div class="card-swatch text-center clearfix" id="product-swatch-' + product.id + '"><ul class="swatch list-unstyled">' + swatchesHTML + '</ul></div>'
        : '';

        // Compare/sale blocks use price_min and compare_at from least variant
        return ''
        + '<div class="product p_v_' + product.id + '" data-p-title="' + product.title + '" data-p-price="' + lease_price.price + '">'
        + '  <div class="product-item" data-product-id="' + product.id + '">'
        + '    <div class="card ajax-loaded">'
        + '      <div class="card-product">'
        + '        <div class="card-product__wrapper">'
        +            percentageHTML
        + '          <a class="card-media card-media--square" href="' + product.url + '" style="padding-bottom: 100%;">'
        + '            <img src="' + featuredImageSrc + '" alt="' + featuredAlt.replace(/"/g, '&quot;') + '" class="wishlist-img-' + product.id + '" loading="lazy">'
        + '            <span class="data-lazy-loading"></span>'
        + '          </a>'
        + '           <div class="card-product__group-item card-wishlist">'
        + '               <a class="wishlist-icon" href="#." data-wishlist="" data-wishlist-handle="' + product.handle + '" data-product-title="' + product.title + '" data-product-id="' + product.id + '" onclick="showWishlistPopup(this)" data-tracking-section="recently-view-product-home-page" data-tracking-value="' + product.title + '" tabindex="0">'                  
        + '                   <img src="https://cdn.shopify.com/s/files/1/0695/1737/7855/files/wish_unslected.svg?v=1736520059" class="unselected-wishlist-icon">'                  
        + '                   <img src="https://cdn.shopify.com/s/files/1/0695/1737/7855/files/wish_selected.svg?v=1736520059" class="selected-wishlist-icon">'                  
        + '               </a>'                  
        + '           </div>'            
        + '          <div class="card-product__group group-right"></div>'
        + '        </div>'
        + '      </div>'
        + '      <div class="card-information">'
        + '        <div class="card-information__wrapper text-center">'
        + '          <a class="card-title link-underline card-title-ellipsis card-title-change" href="' + product.url + '" data-product-title="' + product.title + '" data-product-url="' + product.url + '">'
        + '            <h2 class="text">' + product.title + '</h2>'
        + '          </a>'
        + '          <div class="card-summary card-list__hidden C"></div>'
        +             productMeta
        + '          <div class="card-price">'
        + '            <div class="price price--on-sale">'
        + '              <dl>'
        + '                <div class="price__regular">'
        + '                  <dd class="price__last">'
        + '                    <span class="price-item price-item--regular price-wishlist-p-' + product.id + '">' + price_min + '</span>'
        + '                  </dd>'
        + '                </div>'
        + '                <div class="price__sale">'
        + '                  <dd class="price__last" style="padding-top: 4px;">'
        + '                    <span class="price-item price-item--sale price-wishlist-p-' + product.id + '">' + price_min + '</span>'
        + '                  </dd>'
        + '                  <dd class="price__compare">'
        + '                    <s class="price-item price-item--regular">' + compare_at + '</s>'
        + '                    <span class="product-condition">' + (product.condition || '') + '</span>'
        + '                  </dd>'
        + '                </div>'
        + '              </dl>'
        + '            </div>'
        + '          </div>'
        + '        </div>'
        + '      </div>'
        + '    </div>'
        + '  </div>'
        + '</div>';
    }

  
    function initSlickOnGrid() {
        if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) {
        console.warn('[RecentlyViewed] Slick not found. Load slick before this section.');
        return;
        }
        var $grid = jQuery(grid);

        // If already initialized (e.g., theme editor re-render), destroy first
        if ($grid.hasClass('slick-initialized')) {
        $grid.slick('unslick');
        }

        var isRTL = document.documentElement.getAttribute('dir') === 'rtl';

        $grid.slick({
        infinite: true,
        arrows: true,
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        //autoplay: true,
        rtl: isRTL,
        responsive: [
            { breakpoint: 1171, settings: { slidesToShow: 4, slidesToScroll: 4 } },
            { breakpoint: 769,  settings: { slidesToShow: 3, slidesToScroll: 3 } },
            { breakpoint: 701,  settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 601,  settings: { slidesToShow: 1, slidesToScroll: 1 } }
        ]
        });
    }

    function render(products) {
        // extra safety
        var clean = (products || []).filter(Boolean);
        if (!clean.length) {
            hideSection();
            if (window.jQuery && jQuery.fn && jQuery.fn.slick && jQuery(grid).hasClass('slick-initialized')) {
            jQuery(grid).slick('unslick');
            }
            grid.innerHTML = '';
            return;
        }
        grid.innerHTML = clean.map(createProductHTML).join('');
        showSection();
        initSlickOnGrid();
    }

    function getLangRoot() {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root_url) ? Shopify.routes.root_url : '';
        if (root && root !== '/' && root.endsWith('/')) root = root.slice(0, -1);
        return root || '';
    }

    function fetchRecommendationHandles(productId, limit) {
        var url = getLangRoot() + '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
                    '&limit=' + (limit || 10) + '&intent=related';
        return fetch(url, { credentials: 'same-origin' })
            .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
            .then(json => Array.isArray(json?.products) ? json.products.map(p => p.handle) : [])
            .catch(() => []);
    }

    /* Evenly pick `needed` handles across rec lists */
    function pickEvenly(recHandleLists, seen, needed, currentHandle) {
        if (needed <= 0 || !recHandleLists.length) return [];

        // Clean each list: remove falsy, current, and already-seen; make items unique per list
        var cleaned = recHandleLists.map(list => {
            var uniq = [];
            var s = new Set();
            (list || []).forEach(h => {
            if (!h || h === currentHandle || seen.has(h)) return;
            if (!s.has(h)) { s.add(h); uniq.push(h); }
            });
            return uniq;
        }).filter(arr => arr.length);

        var n = cleaned.length;
        if (!n) return [];

        var picks = [];
        var baseShare = Math.floor(needed / n);
        var remainder  = needed % n;

        // First pass: take baseShare (+1 for the first `remainder` lists)
        for (var i = 0; i < n; i++) {
            var want = baseShare + (i < remainder ? 1 : 0);
            var got = Math.min(want, cleaned[i].length);
            for (var k = 0; k < got; k++) {
            picks.push(cleaned[i][k]);
            seen.add(cleaned[i][k]);
            if (picks.length === needed) return picks;
            }
        }

        // Second pass: round-robin any leftovers until filled or empty
        var cursors = cleaned.map(arr => Math.min(arr.length, baseShare + (cleaned.indexOf(arr) < remainder ? 1 : 0)));
        while (picks.length < needed) {
            var added = false;
            for (var j = 0; j < n && picks.length < needed; j++) {
            var idx = cursors[j];
            if (idx < cleaned[j].length) {
                var h = cleaned[j][idx];
                if (!seen.has(h) && h !== currentHandle) {
                picks.push(h);
                seen.add(h);
                added = true;
                }
                cursors[j] = idx + 1;
            }
            }
            if (!added) break; // nothing left anywhere
        }

        return picks;
    }

    (function init() {
        // Show at least 10 items; if your section sets data-limit higher, respect that.
        var TARGET = Math.max(10, limit);

        // 1) Load history (exclude current PDP)
        var handles = [];
        try { handles = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) {}
        handles = handles.filter(function (h) { return h && h !== currentHandle; });

        // If no history at all, render nothing (or seed with a fallback if you want)
        if (!handles.length) { render([]); return; }

        // 2) Fetch base products (to get IDs for recs), keep order
        Promise.all(handles.map(function (h) { return fetchProduct(h, /*forDisplayOnly*/ false); }))
            .then(function (baseProducts) {
            baseProducts = (baseProducts || []).filter(Boolean);
            if (!baseProducts.length) { render([]); return; }

            // 3) Get recommendations for each base product (handles only)
            return Promise.all(baseProducts.map(function (p) {
                return fetchRecommendationHandles(p.id, 10);
            })).then(function (recLists) {

                // Seed "seen" with the history chunk we’ll try to show first + the current PDP
                var initialHandles = handles.slice(0, TARGET);
                var seen = new Set(initialHandles);
                seen.add(currentHandle);

                // Clean rec lists: unique per list & drop already-seen/current
                recLists = recLists
                .map(function (list) {
                    var out = [], s = new Set();
                    (list || []).forEach(function (h) {
                    if (!h || seen.has(h)) return;
                    if (!s.has(h)) { s.add(h); out.push(h); }
                    });
                    return out;
                })
                .filter(function (arr) { return arr.length; });

                // 4) Fetch initial candidates and early-filter by displayability
                return Promise.all(initialHandles.map(function (h) { return fetchProduct(h, /*forDisplayOnly*/ true); }))
                .then(function (initialProducts) {
                    var displayable = (initialProducts || []).filter(isDisplayable);
                    var remaining = TARGET - displayable.length;

                    if (remaining > 0) {
                    // Evenly pick across all rec lists (pickEvenly already grows "seen")
                    var fillerHandles = pickEvenly(recLists, seen, remaining, currentHandle);

                    return Promise.all(fillerHandles.map(function (h) { return fetchProduct(h, /*forDisplayOnly*/ true); }))
                        .then(function (fillerProducts) {
                        var fillerDisplayable = (fillerProducts || []).filter(isDisplayable);

                        var stillShort = TARGET - (displayable.length + fillerDisplayable.length);
                        if (stillShort > 0) {
                            // One more pass from the same pools, still respecting "seen"
                            var extraHandles = pickEvenly(recLists, seen, stillShort, currentHandle);
                            return Promise.all(extraHandles.map(function (h) { return fetchProduct(h, /*forDisplayOnly*/ true); }))
                            .then(function (extraProducts) {
                                var extraDisplayable = (extraProducts || []).filter(isDisplayable);
                                var finalList = uniqByHandleAndTitle(displayable.concat(fillerDisplayable, extraDisplayable)).slice(0, TARGET);
                                render(finalList);
                            });
                        }

                        var finalList = uniqByHandleAndTitle(displayable.concat(fillerDisplayable)).slice(0, TARGET);
                        render(finalList);
                        });
                    }

                    // Already enough from history alone
                    render(uniqByHandleAndTitle(displayable).slice(0, TARGET));
                });
            });
            })
            .catch(function () { render([]); });
    })();

})();